export class AssignJob {
    constructor(bookingType, specification, selectionType, comment) {
        this.bookingType = bookingType;
        this.specification = specification;
        this.selectionType = selectionType;
        this.comment = comment
    }
}